import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'safePorts';
const BASE_PATH = `${API_ROOT}/safePorts`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: (safePortId) => `${BASE_PATH}/${safePortId}`,
    GET: (safePortId) => `${BASE_PATH}/${safePortId}`,
    LIST: BASE_PATH,
    UPDATE: (safePortId) => `${BASE_PATH}/${safePortId}`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, safePortId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(safePortId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(safePortId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(safePortId)}?${params.toString()}`)).data;
}
function getKey(safePortId, props) {
    return [CacheKey, 'get', safePortId, props];
}
async function list(missionId, props) {
    const params = new URLSearchParams();
    params.append('missionId', missionId);
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(missionId, props) {
    return [CacheKey, 'list', missionId, props];
}
async function update(csrfToken, safePortId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(safePortId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
export default { CacheKey, create, delete_, get, getKey, list, listKey, update };
